import { useState } from "react";
import { Box, LinearProgress, Tab, Tabs, Typography } from "@mui/material";
import { DashboardAccessProvider } from "../../dashboard-framework/DashboardAccessProvider";
import { useNativeDashboards } from "../../dashboard-framework/useNativeDashboards";
import { nativeDashboardRegistry, nativeDashboardRegistryKeys } from "./registry";

export const NativeDashboards = () => {
    const { pageDashboards, status } = useNativeDashboards(nativeDashboardRegistryKeys);
    const [activeTabIndex, setActiveTabIndex] = useState(0);

    if (status === "loading") return <LinearProgress color="secondary" />;
    if (status === "error") {
        return (
            <Typography p={4} color="text.secondary">
                Ocorreu um erro ao carregar os dashboards.
            </Typography>
        );
    }
    if (pageDashboards.length === 0) {
        return (
            <Typography p={4} color="text.secondary">
                Não tem dashboards disponíveis.
            </Typography>
        );
    }

    const safeTabIndex = Math.min(activeTabIndex, pageDashboards.length - 1);
    const activeDashboardRecord = pageDashboards[safeTabIndex];
    const ActiveDashboard = nativeDashboardRegistry[activeDashboardRecord.key];

    return (
        <Box sx={{ minWidth: 0, maxWidth: "100%" }}>
            <Box borderBottom={1} borderColor="divider" sx={{ maxWidth: "100%", overflow: "hidden" }}>
                <Tabs
                    value={safeTabIndex}
                    onChange={(event, newTabIndex) => setActiveTabIndex(newTabIndex)}
                    variant="scrollable"
                    scrollButtons={false}
                >
                    {pageDashboards.map((dashboard) => (
                        <Tab key={dashboard.id} label={dashboard.name} />
                    ))}
                </Tabs>
            </Box>
            <DashboardAccessProvider record={activeDashboardRecord}>
                <ActiveDashboard />
            </DashboardAccessProvider>
        </Box>
    );
};
